export function getLoopingIndex(array: unknown[], index: number): number {
  const length = array.length;
  return ((index % length) + length) % length;
}

export function getPluralisedArrayTitle(singularName: string, pluralName: string, array?: unknown[]): string {
  if (!array || array.length === 0) {
    return `0 ${pluralName}`;
  }
  return `${array.length.toString()} ${array.length > 1 ? pluralName : singularName}`;
}
